export default {"src":"/_next/static/media/bg.e62fc41b.svg","height":287,"width":350,"blurWidth":0,"blurHeight":0};